export const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: 30,

    },
    paper: {
        //padding: 16,
    },
    appbar: {
        position: 'relative',
        zIndex: '1000'
    },
    slide: {
        position: 'relative',
        zIndex: '0',
        minHeight: '100px',
    },
    card: {
        maxWidth: '100%',
    },
    media: {
        height: 200,
        backgroundSize: 'cover'
    },
    centerGrid: {
        flexDirection: 'column',
        flexGrow: 1,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginTop: '8px'
    },
    itemGrid: {
        marginTop: '16px',
        textAlign: 'center',
        width: '100%',
    },
    formControl: {
        marginTop: '16px',
    },
    textInput: {
        marginTop: '24px'
    },
    fullTextInput: {
        margin: '24px 0px 8px 0px',
    },
    fullButton: {
        margin: '5px'
    },
    popperClose: {
        pointerEvents: 'none',
    }

})


// WEBPACK FOOTER //
// ./src/styles.js